<template lang="pug">

div.text-condition.condition

  //- Select the operator (within the last x days, today, etc.)
  v-select.filter__operator(
    :items="operators"
    item-text="name"
    v-model="selectedOperator"
    return-object
  )

  //- When not a date, use this plain text field for numbers
  v-text-field.filter__value.text-field(
    type="text"
    v-model="selectedValue"
    v-if="selectedOperator && selectedOperator.requiresOperand"
  )
  v-tooltip(bottom v-if="value.help")
    template(slot="activator")
      v-icon.help help
    span {{ value.help }}

</template>

<script>

export default {
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    options: {
      type: Array,
      default: () => [],
    },
    operators: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      /**
       * The operator from the list that's been selected
       * @type {Object}
       */
      selectedOperator: null,

      /**
       * The selected condition (operand and value)
       * @type {Object}
       */
      selectedValue: null,
    };
  },

  computed: {
    helpMessage() {
      return this.value && this.value.help;
    },
  },

  mounted() {
    this.setSelectedOperator();
    this.selectedValue = this.value.value;
    this.emitSelected();

    this.$watch('selectedOperator', operator => {
      this.emitSelected();
    });

    this.$watch('selectedValue', selectedValue => {
      this.emitSelected();
    });
  },

  methods: {

    /**
     * Set the selected operator depending on what's been passed in as selected
     */
    setSelectedOperator() {
      this.selectedOperator = this.operators.find(operator => {
        return operator.name === this.value.operator;
      });

      if (!this.selectedOperator) {
        this.selectedOperator = this.operators[0];
      }
    },

    /**
     * Wrapper to emit condition operator & value.
     * Emit at the start
     */
    emitSelected() {

      if (this.selectedValue) {
        this.selectedValue = this.selectedValue.trim();
      }

      const requiresOperand = this.selectedOperator ?
        this.selectedOperator.requiresOperand : true;

      this.$emit('input', {
        operator: this.selectedOperator.name,
        value: this.selectedValue || '',
        requiresOperand,
      });
    },
  },
};
</script>
